import { FC } from 'react';
import { Link, NakedButton } from '@qga/roo-ui/components';
import { openLiveChat } from 'lib/liveChat/actions';

import * as track from 'lib/gaTracking/crossPageEvents';
import { CONTACT_US_URL, CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';
import TelLink from 'components/TelLink';

export const ContactUsResolution: FC = () => {
  const handleLiveChatClick = () => {
    openLiveChat();
    track.expiredCreditCardModalLinkSelected('live chat');
  };

  const handleEmailClick = () => {
    track.expiredCreditCardModalLinkSelected('email');
  };

  const handlePhoneClick = () => {
    track.expiredCreditCardModalLinkSelected('call customer support');
  };

  const handleInternationalPhoneClick = () => {
    track.expiredCreditCardModalLinkSelected('call international customer support');
  };

  return (
    <>
      To continue with your booking, please contact us via{' '}
      <Link as={NakedButton} onClick={handleLiveChatClick} underline>
        live chat
      </Link>
      ,{' '}
      <Link target="_blank" href={CONTACT_US_URL} onClick={handleEmailClick} underline>
        email
      </Link>
      , or call <TelLink number={CUSTOMER_SUPPORT_HOTLINE_AU} color="greys.steel" underline onClick={handlePhoneClick} /> (outside
      Australia: <TelLink number={CUSTOMER_SUPPORT_HOTLINE_INTL} color="greys.steel" underline onClick={handleInternationalPhoneClick} />
      ).
    </>
  );
};
